module.exports = __webpack_public_path__ + "269dd2e422e52220b416ad198853042b.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/B_W9.jpg
// module id = 3308
// module chunks = 0